import type { ArColumnDefinition } from '#types/System.Artifacts.types';
import type { SplitQuery } from '#types/System.types';
import type { ArTableSplit } from './ArTableSplit';

type ResolveSplitForTableParams = {
  columns: readonly ArColumnDefinition[];
  splitQuery: SplitQuery | undefined;
};

function resolveSplitForTable({
  columns,
  splitQuery,
}: ResolveSplitForTableParams): ArTableSplit | null {
  const valuePath = splitQuery?.splitRef?.valuePath;
  const queryValue = splitQuery?.queryValue;
  const mode = splitQuery?.mode;

  if (mode !== 'include') return null;
  if (!valuePath || typeof valuePath !== 'string') return null;
  if (queryValue === undefined || queryValue === null) return null;

  const column = columns.find((c) => c.typeId === valuePath);
  if (!column) return null;

  return { typeId: column.typeId, filterValue: String(queryValue) };
}

export { resolveSplitForTable };
